import FormatosReanimate from '../res/formatosReanimate.js'

export default function UpdateFormats(newFormats, client) {
  let format = FormatosReanimate(client);
  for (var i = 0; i < format.formats.length; i++) {
    for (var j = 0; j < newFormats.length; j++) {
      if (format.formats[i].width === newFormats[j][0] && format.formats[i].height === newFormats[j][1]) format.formats[i].ativo = true;
    }
  }
  
  return format;
}